import { Injectable } from '@angular/core';
import { Dealer } from '../models/dealer.model';
import { environment } from '../../environments/environment'
import { first, map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DealerEmployee } from '../models/dealer-employee.model';
import { DealerCountry } from '../models/dealer-country.model';
import { Group } from '../models/group.model';

@Injectable({
  providedIn: 'root'
})
export class DealersService {

  public viewDashboardAs: Dealer;
  public observableViewAsId : BehaviorSubject<Dealer>;

  constructor(private http : HttpClient) {
    this.observableViewAsId = new BehaviorSubject<Dealer>(this.viewDashboardAs);
  }

  setViewAs(dealer : Dealer) {
    this.viewDashboardAs = dealer;
    this.observableViewAsId.next(this.viewDashboardAs);
  }

  search(offset: number, take: number, searchValue?: string, regionFilter? : string, zoneFilter? : string, districtFilter? : string, sortBy? : string, sortDirection? : string) {
    var queryString = `/dealers/search?offset=${offset}&take=${take}`;
    if (searchValue != undefined) queryString += `&searchValue=${searchValue}`;
    if (regionFilter != undefined) queryString += `&regionFilter=${regionFilter}`;
    if (zoneFilter != undefined) queryString += `&zoneFilter=${zoneFilter}`;
    if (districtFilter != undefined) queryString += `&districtFilter=${districtFilter}`;
    if (sortBy != undefined) queryString += `&sortBy=${sortBy}`;
    if (sortDirection != undefined) queryString += `&sortDirection=${sortDirection}`;
    return this.http.get<Dealer[]>(`${environment.apis.thirdParty}${queryString}`);
  }

  searchFilters(filter: string, searchValue? : string, regionFilter? : string, zoneFilter? : string) {
    var queryString = `/dealers/searchFilters?filter=${filter}`;
    if (searchValue != undefined) queryString += `&searchValue=${searchValue}`;
    if (regionFilter != undefined) queryString += `&regionFilter=${regionFilter}`;
    if (zoneFilter != undefined) queryString += `&zoneFilter=${zoneFilter}`;
    return this.http.get<string[]>(`${environment.apis.thirdParty}${queryString}`);
  }
  
  getDealersByVendorIds(vendorIds : string[]) : Observable<Dealer[]> {
    return this.http.post<Dealer[]>(`${environment.apis.thirdParty}/dealers/getByVendorIds`, vendorIds);
  }

  getEmployeesForDealership(bac? : string, refreshCache?: boolean) {
    let url = `${environment.apis.thirdParty}/dealers/employees`;
    if (bac) url += `?bac=${bac}`;
    if (refreshCache) {
      if (bac) url += '&refreshCache=1';
      else url += `?refreshCache=1`;
    } 
    return this.http.get<DealerEmployee[]>(url);
  }

  getDealerCountries() {
    return this.http.get<DealerCountry[]>(`${environment.apis.thirdParty}/dealers/countries`);
  }
}
